import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { RevealSection, StaggerGrid } from './shared';

export const TeamSection = ({ sid, theme, txt, teamMembers }) => (
  <section id={sid} className="py-16 sm:py-28 bg-slate-50" data-testid="team-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <RevealSection className="text-center mb-16">
        <div className="inline-block mb-4 px-4 py-1.5 rounded-full text-sm font-medium" style={{ backgroundColor: `${theme.primary_color}10`, color: theme.primary_color }}>{txt('team', 'badge')}</div>
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold text-slate-900 mb-4" style={{ fontFamily: `${theme.font_heading}, sans-serif` }}>{txt('team', 'title')}</h2>
        <p className="text-base md:text-lg text-slate-500" style={{ fontFamily: `${theme.font_body}, sans-serif` }}>{txt('team', 'subtitle')}</p>
      </RevealSection>
      <StaggerGrid className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        {(teamMembers.length > 0 ? teamMembers : [
          { id: '1', name: 'Monika', role: 'Kontaktní osoba', email: 'info@solar-green.cz', phone: '+420 602 65 90 14', image_url: '/api/uploads/team_monika.jpeg' },
          { id: '2', name: 'Dušan', role: 'Kontaktní osoba', email: 'info@energomat.cloud', phone: '+420 604 943 419', image_url: '/api/uploads/team_dusan.jpeg' },
          { id: '3', name: 'Evelin', role: 'Kontaktní osoba', email: 'info@solar-green.cz', phone: '+420 608 808 815', image_url: '/api/uploads/team_evelin.jpeg' }
        ]).map((member, index) => (
          <Card key={member.id || index} className="card-lift overflow-hidden border border-slate-100 rounded-2xl bg-white group shadow-md hover:shadow-2xl" data-testid={`team-member-${index}`}>
            <div className="relative h-64 overflow-hidden">
              <img src={member.image_url || 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop'} loading="lazy" alt={member.name} className="w-full h-full object-cover team-photo-effect" style={{ objectPosition: member.name?.includes('Monika') ? '40% 20%' : 'center top' }} />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4">
                <h3 className="text-xl font-bold text-white mb-1" style={{ fontFamily: `${theme.font_heading}, sans-serif` }}>{member.name}</h3>
                <p className="text-white/80 text-sm font-medium">{member.role}</p>
              </div>
            </div>
            <div className="p-5 space-y-3">
              {member.email && (
                <a href={`mailto:${member.email}`} className="flex items-center text-sm text-slate-600 hover:text-slate-900 transition-colors group/link">
                  <Mail className="w-4 h-4 mr-3 flex-shrink-0" style={{ color: theme.primary_color }} />
                  <span className="truncate group-hover/link:underline">{member.email}</span>
                </a>
              )}
              {member.phone && (
                <a href={`tel:${member.phone.replace(/\s/g, '')}`} className="flex items-center text-sm text-slate-600 hover:text-slate-900 transition-colors group/link">
                  <Phone className="w-4 h-4 mr-3 flex-shrink-0" style={{ color: theme.primary_color }} />
                  <span className="group-hover/link:underline">{member.phone}</span>
                </a>
              )}
            </div>
          </Card>
        ))}
      </StaggerGrid>
    </div>
  </section>
);
